export const routesRaporProje = [
  {
    path: "/rapor_proje",
    name: "rapor_proje",
    component: () => import("@/views/mesai/rapor_proje/index.vue"),
    meta: {
      public: false,
      title: "mesai.Proje Rapor",
      yetki: { k: [1012302] },
    },
  },
]
